import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { OnlineSchedulingParams } from 'interfaces/onlineSchedulingParams';

export interface ShowRateValueDetail {
  date: string;
  totalAppointments: number;
}

export interface ShowRateValue {
  showRates: number;
  details: ShowRateValueDetail[];
}

export interface RoiShowRateResponse {
  periodData: ShowRateValue;
  lastPeriodData: ShowRateValue;
}

const useShowRate = (params: OnlineSchedulingParams) => {
  const storedId = loadSelectedClinicId();
  const clinicIds = params.clinicIds ?? [storedId];
  const query =
    params.startDate && params.endDate
      ? new URLSearchParams({
          startDate: params.startDate,
          endDate: params.endDate,
          hourType: params.hourType,
        }).toString()
      : '';

  const url =
    params.startDate && params.endDate ? `/rois/show-rates?${query}` : null;

  const { data, error, isValidating, mutate } = useSWR(
    url ? [url, clinicIds] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<RoiShowRateResponse>(url, {
        params: { clinicIds },
      });
      return response.data;
    }
  );

  if (!params.startDate || !params.endDate) {
    return {
      data: null,
      error: undefined,
      isLoading: false,
      isValidating: false,
      mutate: async () => {},
    };
  }

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  };
};

export default useShowRate;
